const FALLBACK = '/';

/**
 * Routes that themselves redirect. Returning to one after login would bounce
 * the user straight back out again, so they are never captured as a target.
 */
const NON_RETURNABLE = [/^\/login(?=$|[/?#])/];

/**
 * Validates a post-login redirect target taken from the URL.
 *
 * Only same-site absolute paths are allowed. Anything protocol-relative
 * (`//evil.com`, and the `/\evil.com` variant browsers normalise the same way)
 * would send the user off-site with our redirect, so it falls back instead.
 */
export function safeNextPath(value: string | null | undefined): string {
	if (!value) return FALLBACK;

	const candidate = value.trim();
	if (!candidate.startsWith('/')) return FALLBACK;
	if (candidate.startsWith('//') || candidate.startsWith('/\\')) {
		return FALLBACK;
	}
	if (NON_RETURNABLE.some((pattern) => pattern.test(candidate))) {
		return FALLBACK;
	}

	return candidate;
}

/** Builds the `/login` URL that returns to `target` once signed in. */
export function loginPathFor(target: string): string {
	const next = safeNextPath(target);
	if (next === FALLBACK) return '/login';
	return `/login?next=${encodeURIComponent(next)}`;
}
